import React, { useEffect, useState } from 'react';
import './Loader.css';

const greetings = ['Hello', 'Báwo ni', 'Bonjour', 'Hola', 'Ciao', 'Kedu', 'Hallo', 'Hello'];

export default function Loader({ onDone }) {
  const [index, setIndex] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    let timer;
    if (index < greetings.length - 1) {
      timer = setTimeout(() => setIndex(i => i + 1), index === 0 ? 420 : 170);
    } else {
      timer = setTimeout(() => {
        setLeaving(true);
        onDone();
      }, 500);
    }
    return () => clearTimeout(timer);
  }, [index, onDone]);

  return (
    <div className={`loader ${leaving ? 'done' : ''}`} aria-hidden="true">
      <p><span className="loader-dot" />{greetings[index]}</p>
    </div>
  );
}
